// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'user-information';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M.563 12.938a5.064 5.064 0 0 1 7.05-4.656M5.625 6.75a3.094 3.094 0 1 0 0-6.188 3.094 3.094 0 0 0 0 6.188zm7.313 10.688a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9zm0-2.25v-2.25' />
    <path d='M12.938 11.25a.281.281 0 1 1 0-.563m0 .563a.281.281 0 1 0 0-.563' />
  </g>
);

export const viewBox = '0 0 18 18';
